import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ExternalsParametersService } from '../externals-parameters.service';
import { ExternalParameters } from 'src/app/models/external-parameters';
import { ChangepasswordComponent } from 'src/app/components/password/changepassword/changepassword.component';
import { ForgottenPasswordComponent } from 'src/app/components/password/forgotten-password/forgotten-password.component';

@Injectable({
    providedIn: 'root',
})
export class ResetPasswordGuard {
    private RESETPASSWORD_PARAMETER = 'resetPassword';
    private EXTERNAL_PARAMETER = 'parameters';

    constructor(
        private router: Router,
        private externalsParametersService: ExternalsParametersService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const params = { ...next.queryParams };

        if (next.component === ChangepasswordComponent && params[this.RESETPASSWORD_PARAMETER]) {
            if (params[this.EXTERNAL_PARAMETER]) {
                console.log(JSON.parse(params[this.EXTERNAL_PARAMETER]));
                this.externalsParametersService.loadExternalParameters(JSON.parse(params[this.EXTERNAL_PARAMETER]) as ExternalParameters);

                delete params[this.EXTERNAL_PARAMETER];

                this.router.navigate([state.url.substring(0, state.url.indexOf('?'))], { queryParams: params });
            }

            return true;
        } else if (next.component === ForgottenPasswordComponent) {
            if (params[this.EXTERNAL_PARAMETER]) {
                console.log(JSON.parse(params[this.EXTERNAL_PARAMETER]));
                this.externalsParametersService.loadExternalParameters(JSON.parse(params[this.EXTERNAL_PARAMETER]) as ExternalParameters);

                delete params[this.EXTERNAL_PARAMETER];

                this.router.navigate([state.url.substring(0, state.url.indexOf('?'))], { queryParams: params });
            }

            return true;
        } else {
            this.router.navigate(['/login']);
            return false;
        }
    }
}
